<template>
  <div class="WechartPayDialog">
    <el-dialog v-dialogDragOnly :close-on-click-modal="false" custom-class="sm-dialog" append-to-body :visible="visible" :before-close="hideAdd">
      <template v-slot:title>
        <img :src="WechartPay" alt class="wechart-pay" width="90">
      </template>
      <div class="WechartPay-content">
        <div class="content-header">
          <p><span>{{$t('portal.er-wei-ma-you-xiao-qi')}}<span class="show-time">{{qrCodePeriodFormat}}</span></span></p>
          <p><span>{{$t('portal.zhi-fu')}}<span class="show-money">￥{{Number(propData.payAmount).toLocaleString('en-US', {minimumFractionDigits: 2})}}</span></span></p>
        </div>
        <canvas ref="qr_code" id="qr_code"></canvas>
        <p class="content-footer">{{$t('portal.wei-xin-sao-ma-tip')}}</p>
      </div>
      <div class="foot-btm">
        <el-button class="dio-btn" size="mini" type="primary" @click="hideAdd">{{$t('common.done')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import WechartPay from '~/common/assets/img/wechat-pay.png';
import QRCode from 'qrcode';
import moment from 'moment';
var T = ''; //定时器标识
export default {
  name: 'WechartPayDialog',
  components: {},
  props: {
    propData: {
      type: Object,
      default: () => ({
        qrString: 'qrCode',
        //二维码字符串
        qrCodePeriod: 0,
        payAmount: 0 //充值金额
      })
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      qrCodePeriodFormat: '',
      WechartPay
    };
  },
  watch: {
    visible: {
      handler: function (newVal) {
        let that = this;
        if (newVal) {
          this.$nextTick(function () {
            QRCode.toCanvas(this.$refs.qr_code, this.propData.qrString, {
              width: 250,
              height: 250,
              margin: 1
            }, function (err) {
              if (err) throw err;
              // 轮询查询是否扫码支付
              that.checkPay();
            });
          });
        }
      }
    },
    propData: {
      handler: function (val) {
        if (val.qrCodePeriod) {
          this.setTime();
        }
      }
    }
  },
  created() {},
  computed: {},
  methods: {
    checkPay() {
      if (!this.visible) {
        //弹窗关闭，则关掉轮询
        return;
      }
      this.$axios.$post(`rest/store/hub/v3/payment/payResult`, {
        id: this.propData.id,
        pay_method: 'wechat',
        order_id: this.propData.order_id
      }, {
        headers: {
          showNotify: false
        }
      }).then(({
        code,
        data,
        msg
      }) => {
        if (code !== 200) {
          this.hideAdd({
            type: 'error',
            msg: msg
          }); //支付失败
          return;
        }
        ;
        // 100：未支付、200：支付成功、400：支付失败
        if (data.status === '200') {
          this.hideAdd({
            type: 'success',
            msg: data.message,
            out_trade_no: data.out_trade_no
          }); //支付成功
        } else if (data.status === '100') {
          if (+new Date() < this.propData.qrCodePeriod) {
            //二维码如果没有过期的话，则轮询
            setTimeout(() => {
              this.checkPay();
            }, 1000);
          }
        } else {
          this.hideAdd({
            type: 'error',
            msg: data.message
          }); //支付失败
        }
      });
    },
    setTime() {
      let now = +new Date();
      let endtime = this.propData.qrCodePeriod;
      T = setInterval(() => {
        this.qrCodePeriodFormat = moment.utc(endtime - now).format('HH:mm:ss');
        now += 1000;
        if (now >= endtime) {
          this.qrCodePeriodFormat = this.$t('portal.er-wei-ma-yi-guo-qi');
          clearInterval(T);
        }
      }, 1000);
    },
    hideAdd(data = {}) {
      // 手动触发关掉弹窗时，也要关掉计时器
      clearInterval(T);
      this.$emit('hide', data);
    }
  }
};
</script>

<style lang="less">
.WechartPay-content {
  text-align: center;
  padding: 0 20px 0;
  .content-header {
    display: flex;
    justify-content: space-between;
    .show-time {
      color: red;
    }
    .show-money {
      font-size: 18px;
      color: red;
    }
  }
  #qr_code {
    margin: 30px 0;
  }
  .content-footer {
    margin: 10px 0;
  }
}
.foot-btm {
  text-align: center;
}
</style>
